'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = require('vue');

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = require('vue-router');

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _router = require('@/config/interceptors/router');

var _course = require('./course');

var _course2 = _interopRequireDefault(_course);

var _userCenter = require('./user-center');

var _userCenter2 = _interopRequireDefault(_userCenter);

var _play = require('./play');

var _play2 = _interopRequireDefault(_play);

var _qusetionnaire = require('./qusetionnaire');

var _qusetionnaire2 = _interopRequireDefault(_qusetionnaire);

var _assessment = require('./assessment');

var _assessment2 = _interopRequireDefault(_assessment);

var _exam = require('./exam');

var _exam2 = _interopRequireDefault(_exam);

var _teacher = require('./teacher');

var _teacher2 = _interopRequireDefault(_teacher);

var _class = require('./class');

var _class2 = _interopRequireDefault(_class);

var _dxClass = require('./dx-class');

var _dxClass2 = _interopRequireDefault(_dxClass);

var _onLine = require('./on-line');

var _onLine2 = _interopRequireDefault(_onLine);

var _resources = require('./resources');

var _resources2 = _interopRequireDefault(_resources);

var _notice = require('./notice');

var _notice2 = _interopRequireDefault(_notice);

var _noticeAnnouncement = require('./notice-announcement');

var _noticeAnnouncement2 = _interopRequireDefault(_noticeAnnouncement);

var _index = require('./dynamic/index.js');

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var retrieve = function retrieve() {
  return import('@/page/retrieve/retrieve');
};
var resetPasswords = function resetPasswords() {
  return import('@/page/resetPasswords/resetPasswords');
}; // 修改密码路由
var resetPhone = function resetPhone() {
  return import('@/page/resetPhone/resetPhone');
}; // 修改手机号路由
var resetEmail = function resetEmail() {
  return import('@/page/resetEmail/resetEmail');
}; // 修改邮箱
var bindPhone = function bindPhone() {
  return import('@/page/bindPhone/bindPhone');
}; // 绑定手机号路由
var validPhone = function validPhone() {
  return import('@/page/validPhone/validPhone');
}; // 互联网端二次登录路由cons
var applicationSecret = function applicationSecret() {
  return import('@/page/application-secret');
};
var appDownload = function appDownload() {
  return import('@/page/app-download');
};
var login = function login() {
  return import('@/page/login');
};
var index = function index() {
  return import('@/page/index');
};
_vue2.default.use(_vueRouter2.default);
var routes = exports.routes = [{
  path: '/',
  name: 'login',
  component: login
}, {
  path: '/index',
  name: 'index',
  component: index
}, {
  path: '/retrieve',
  name: 'retrieve',
  component: retrieve
}, {
  path: '/emailReset',
  name: 'emailReset',
  component: retrieve
}, {
  path: '/validPhone',
  name: 'validPhone',
  component: validPhone
}, {
  path: '/resetPasswords',
  name: 'resetPasswords',
  component: resetPasswords
}, {
  path: '/resetPhone',
  name: 'resetPhone',
  component: resetPhone
}, {
  path: '/resetEmail',
  name: 'resetEmail',
  component: resetEmail
}, {
  path: '/bindPhone',
  name: 'bindPhone',
  component: bindPhone
}, {
  path: '/applicationSecret',
  name: 'applicationSecret',
  component: applicationSecret,
  meta: {
    code: 'application_secret'
  }
}, {
  path: '/appDownload',
  name: 'appDownload',
  component: appDownload,
  meta: {
    code: 'appDownload'
  }
}, {
  path: '/techAuth',
  name: 'techAuth',
  component: applicationSecret,
  meta: {
    code: 'techsupport'
  }
}].concat((0, _toConsumableArray3.default)(_index2.default), (0, _toConsumableArray3.default)(_course2.default), (0, _toConsumableArray3.default)(_userCenter2.default), (0, _toConsumableArray3.default)(_play2.default), (0, _toConsumableArray3.default)(_qusetionnaire2.default), (0, _toConsumableArray3.default)(_assessment2.default), (0, _toConsumableArray3.default)(_teacher2.default), (0, _toConsumableArray3.default)(_exam2.default), (0, _toConsumableArray3.default)(_resources2.default), (0, _toConsumableArray3.default)(_class2.default), (0, _toConsumableArray3.default)(_dxClass2.default), (0, _toConsumableArray3.default)(_onLine2.default), (0, _toConsumableArray3.default)(_notice2.default), (0, _toConsumableArray3.default)(_noticeAnnouncement2.default));
var routerInstance = new _vueRouter2.default({
  routes: routes,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
  }
});
routerInstance.beforeEach(_router.routerBeforeEach);
routerInstance.afterEach(_router.routerAfterEach);
exports.default = routerInstance;